import * as Yup from 'yup';

const atLeastOneLowerCaseChar = '(?=.*[a-z])';
const atLeastOneUpperCaseChar = '(?=.*[A-Z])';
const atLeastOneNumber = '(?=.*[0-9])';
const atLeastOneSpecialChar = '(?=.*[!@#$%^&*])';
const atLeastEightCharacters = '(?=.{8,})';

const passwordRequirements = new RegExp(
  '^' +
    atLeastOneLowerCaseChar +
    atLeastOneUpperCaseChar +
    atLeastOneNumber +
    atLeastOneSpecialChar +
    atLeastEightCharacters,
);

const notValidPassword = 'validator.error.notValidPassword';

export const PasswordSchema =
  Yup.string().matches(passwordRequirements, notValidPassword) ||
  Yup.string().max(0);
